import { Divider, styled } from '@mui/material';

const HelpDivider = styled(Divider)({
    margin: '1.5rem -2rem',
    color: 'rgba(0, 0, 0, 0.615)',
});

export default HelpDivider;
